import { t } from './i18n';

// Suivi des enregistrements : compte les mutations GraphQL en cours pour l'indicateur « Enregistrement… / Enregistré ».
let pending = 0;
let state = { status: 'idle', savedAt: null }; // idle | saving | saved | error
const listeners = new Set();

const emit = () => listeners.forEach((fn) => fn(state));

export const getSaveState = () => state;

export function subscribeSaveState(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function saveStarted() {
  pending += 1;
  state = { ...state, status: 'saving' };
  emit();
}

export function saveFinished(failed) {
  pending = Math.max(0, pending - 1);
  if (failed) state = { ...state, status: 'error' };
  else if (pending === 0 && state.status !== 'error') state = { status: 'saved', savedAt: Date.now() };
  emit();
}

// Une nouvelle réussite après une erreur remet l'état à « enregistré » quand plus rien n'est en cours.
export function clearSaveError() {
  if (pending === 0 && state.status === 'error') {
    state = { status: 'idle', savedAt: state.savedAt };
    emit();
  }
}

// Prévient avant de fermer l'onglet tant qu'un enregistrement est encore en cours.
window.addEventListener('beforeunload', (e) => {
  if (pending > 0) {
    e.preventDefault();
    e.returnValue = t('ui.save.leave');
    return e.returnValue;
  }
  return undefined;
});
